module.exports = __webpack_public_path__ + "img/dennis-car-bed.dffaa80e.jpg";